<template >
	<el-container  direction="vertical"class="bgcolor">
		<!-- <el-header style="text-align: right;">
			<span><el-button type="text" size="big"  @click="tomain()">首页</el-button></span>
			<el-divider direction="vertical" ></el-divider>
			<el-button type="text" size="big"  @click="tologin()">退出登录</el-button>
		</el-header> -->
		
		<el-container v-if="showmenu" >
			<!-- <el-page-header @back="tologin()" content="体检预约">
			</el-page-header> -->
			<el-header >
				<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="tologin()" icon="el-icon-arrow-left" type="text"></el-button>
				<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="tologin()" :src='"/img/webimg/back.png"' alt=""> -->
				<!-- <span style="font-size: 28px; float: left;" @click="tologin()">く</span> -->
				<span class="header_h2">体检预约</span>
			</el-header>
			<el-main >
			<el-row  type="flex" justify="center">
				<el-col :span="8">
					<img @click="tobook()" style=" width:105px ;height: auto;" :src='"/img/webimg/yy.png"' alt="">
					<!-- <button class="bigButton" @click="tobook()">预约体检</button> -->
				</el-col>
				<el-col :span="8">
					<img @click="tobooked()" style="width:105px; height: auto;" :src='"/img/webimg/yyjl.png"' alt="">
					<!-- <button class="bigButton" @click="tobooked()">预约记录</button> -->
				</el-col>
				<el-col :span="8">
					<img @click="toreport()" style="width:105px;height: auto;" :src='"/img/webimg/rpt.png"' alt="">
					<!-- <button class="bigButton" @click="toreport()">查看报告</button> -->
				</el-col>
			<!-- </el-row>
			<el-row style="width: 100%;"> -->
				
				
				<!-- <el-col :span="12">
					<img @click="tomorder()" style="max-width:150px ; width:auto ;height: auto;" :src='"/img/webimg/ord.png"' alt="">
					<button class="bigButton" @click="tomorder()">我的订单</button>
				</el-col> -->
			</el-row>
			
			</el-main>
		</el-container>

			<el-container>
			<RouterView></RouterView>
		</el-container>
		
	</el-container>
</template>

<script>
	import corp from '../apifunction/Corp.js'
	import order from '../apifunction/Order.js'
	import cusinfo from '../apifunction/OrderCus.js'
	export default {
		data() {
			return {
				mobile: '',
				showmenu:true
			};
		},
		watch:{
			$route( to , from ){ this.showmenu = this.$route.query.showmenu;  }
		},
		created() {
			this.mobile = this.$route.query.mobile;
			this.showmenu = this.$route.query.showmenu;
			// this.tomain();
			},
		methods: {
			tologin() {
				this.$store.commit('$_removeStorage'); 
				this.$router.push('loginbook');
				this.$router.go(0)
				// 
			},
			toreport() {
				this.showmenu=false;
				var data = {
					path: '/HistoryReport',
					query: {
						mobile: this.mobile
					}
				}
				this.$router.push(data)
			},
			tomain() {
				// this.showmenu=true;
				var data = {
					path: '/mainbook',
					query: {
						mobile: this.mobile,
						showmenu:true
					}
				
				}
				this.$router.push(data)
				// this.$router.push("goodsmain")
			},
			tobook(cus) {
				this.showmenu=false;
				var data = {
					path: '/BookCusList',
					query: {
						mobile: this.mobile
					}
				}
				this.$router.push(data)
			},
			tobooked(cus) {
				this.showmenu=false;
				var data = {
					path: '/BookedCusList',
					query: {
						mobile: this.mobile
					}
				}
				this.$router.push(data)
			},
			
			tomorder(){
				this.showmenu=false;
				this.$router.push("MOrderList")
			}
		}
	}
</script>

<style>
</style>
